import React, { useEffect, useState } from "react";
import { InvoiceList } from "../invoice-list";
import { Banner, BannerProps } from "kubra-ux-forge";

export const InvoiceListView = () => {
  const [bannerState, setBannerState] = useState<BannerProps>({
    active: false,
    variant: "error",
    messageLabel: "",
  });

  useEffect(() => {
    // scroll to top when banner shows up
    if (bannerState.active) {
      // scrolls to top in Safari
      document.body.scrollTop = 0;
      // scrolls to top in Chrome, Firefox, IE, and Opera
      document.documentElement.scrollTop = 0;
      // Mobile view
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [bannerState.active]);

  return (
    <>
      <div className="ez-pay-payable-banner">
        <Banner
          {...bannerState}
          onClose={() => setBannerState((prev) => ({ ...prev, active: false }))}
        ></Banner>
      </div>
      <div className="invoice-list-container">
        <InvoiceList setBannerState={setBannerState} />
      </div>
    </>
  );
};
